export const PAGE_CONFIG = {
  "title": "Lifetime Sales",
  "titleCN": "累计销售数据",
  "subTitle": "",
  "subTitleCN": "",
  "path": "/overview/lifetime",
  "defaultTab": "lifetime",
  "tabList": [
    {
      "id": "lifetime",
      "tabName": "Lifetime Sales",
      "tabNameCN": "累计销售数据",
      "isHaveNotification": true,
      "notificationPath": "/overview/lifetime",
      "path": "/overview/lifetime",
      "tabIcon": "chart-map",
      "logConfig": {
        "pageId": "205602",
        "pageName": "lifetime",
        "extInfo": "lifetime",
        "pagePath": "/overview/lifetime"
      },
      "filters": [
        {
          "name": "LifetimeFIlter",
          "isOpenSticky": true,
          "isHaveFilterSave": true,
          "filterPath": "/overview/lifetime",
          "data": {
            "metric": "wow_map_cnt",
            "by_tab": "gross",
            "by_type": "product",
            "by_top10_metric": "lifetime_revenue_after_refund"
          },
          "componentList": [
            {
              "name": "KeyMetricTitle",
              "className": "",
              "type": "view",
              "style": {},
              "props": {
                "config": {
                  "dateFilterType": "singleDaily"
                }
              }
            },
            {
              "name": "SegmentCo",
              "className": "segment-light",
              "style": { "margin-top": "8px" },
              "props": {
                "config": {
                  "dataKey": "by_tab",
                  "options": [
                    {
                      "name": "Gross",
                      "nameCn": "总口径",
                      "value": "gross",
                      "bubble": "",
                      "bubbleCn": ""
                    },
                    {
                      "name": "After Refund",
                      "nameCn": "去除退款口径",
                      "value": "after_refund",
                      "bubble": "",
                      "bubbleCn": ""
                    }
                  ]
                }
              },
              "children": [
                {
                  id: 'gross',
                  name: 'LifetimeCardContainer',
                  children: [
                    {
                      "name": "PlatformMetricsCo",
                      "style": { "margin-top": "20px" },
                      "type": "view",
                      "props": {
                        "config": {
                          "api": "/api/v1/dashboard/pc/monetization/sales/lifetime/card_metrics",
                          "dateFilterType": "singleDaily",
                          "isConfirm": true,
                          "metricsList": [
                            "lifetime_full_game_gross_units"
                          ]
                        }
                      },
                      "children": [
                        {
                          "name": "CommonRow",
                          "className": "",
                          "type": "layout",
                          "style": {},
                          "props": {},
                          "children": [
                            {
                              "name": "CommonCol",
                              "className": "",
                              "type": "layout",
                              "style": {},
                              "props": {
                                "w": 24
                              },
                              "children": [
                                {
                                  "name": "PlatformCard",
                                  "className": "",
                                  "style": {},
                                  "type": "view",
                                  "props": {
                                    "config": {
                                      "componentMetrics": [
                                        {
                                          "metricKey": "lifetime_full_game_gross_units",
                                          "enName": "Lifetime Gross Base Game Units",
                                          "cnName": "累计本体销量",
                                          "rangeEnName": "Lifetime Gross Base Game Units",
                                          "rangeCnName": "累计本体销量",
                                          "preUnit": "",
                                          "endUnit": "",
                                          "rainbowKey": "Pc Lifetime Gross Base Game Units",
                                          "type": "int",
                                          "decimal": 0,
                                          "icon": "game",
                                          "position": ""
                                        }
                                      ]
                                    }
                                  },
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "name": "PlatformMetricsCo",
                      "className": "dbd-lifetime-card-not-one",
                      "type": "view",
                      "style": { "margin-top": "20px" },
                      "props": {
                        "config": {
                          "api": "/api/v1/dashboard/pc/monetization/sales/lifetime/card_metrics",
                          "dateFilterType": "singleDaily",
                          "isConfirm": true,
                          "metricsList": [
                            "lifetime_gross_revenue"
                          ]
                        }
                      },
                      "children": [
                        {
                          "name": "CommonRow",
                          "className": "",
                          "type": "layout",
                          "style": {},
                          "props": {},
                          "children": [
                            {
                              "name": "CommonCol",
                              "className": "",
                              "type": "layout",
                              "style": {},
                              "props": {
                                "w": 24
                              },
                              "children": [
                                {
                                  "name": "PlatformCard",
                                  "className": "",
                                  "style": {},
                                  "type": "view",
                                  "props": {
                                    "config": {
                                      "componentMetrics": [
                                        {
                                          "metricKey": "lifetime_gross_revenue",
                                          "enName": "Lifetime Gross Revenue",
                                          "cnName": "累计总收入",
                                          "rangeEnName": "Lifetime Gross Revenue",
                                          "rangeCnName": "累计总收入",
                                          "preUnit": "$",
                                          "endUnit": "",
                                          "rainbowKey": "Pc Lifetime Gross Revenue",
                                          "type": "decimals",
                                          "decimal": 2,
                                          "icon": "dollar",
                                          "position": ""
                                        }
                                      ]
                                    }
                                  },
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    },
                  ]
                },
                {
                  id: 'after_refund',
                  name: 'LifetimeCardContainer',
                  children: [
                    {
                      "name": "PlatformMetricsCo",
                      "style": { "margin-top": "20px" },
                      "type": "view",
                      "props": {
                        "config": {
                          "api": "/api/v1/dashboard/pc/monetization/sales/lifetime/card_metrics",
                          "dateFilterType": "singleDaily",
                          "isConfirm": true,
                          "metricsList": [
                            "lifetime_full_game_net_units"
                          ]
                        }
                      },
                      "children": [
                        {
                          "name": "CommonRow",
                          "className": "",
                          "type": "layout",
                          "style": {},
                          "props": {},
                          "children": [
                            {
                              "name": "CommonCol",
                              "className": "",
                              "type": "layout",
                              "style": {},
                              "props": {
                                "w": 24
                              },
                              "children": [
                                {
                                  "name": "PlatformCard",
                                  "className": "",
                                  "style": {},
                                  "type": "view",
                                  "props": {
                                    "config": {
                                      "componentMetrics": [
                                        {
                                          "metricKey": "lifetime_full_game_net_units",
                                          "enName": "Lifetime Base Game Units After Refund",
                                          "cnName": "累计本体销量(剔除退款)",
                                          "rangeEnName": "Lifetime Base Game Units After Refund",
                                          "rangeCnName": "累计本体销量(剔除退款)",
                                          "preUnit": "",
                                          "endUnit": "",
                                          "rainbowKey": "Pc Lifetime Base Game Units After Refund",
                                          "type": "int",
                                          "decimal": 0,
                                          "icon": "game",
                                          "position": ""
                                        }
                                      ]
                                    }
                                  },
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "name": "PlatformMetricsCo",
                      "className": "dbd-lifetime-card-not-one",
                      "type": "view",
                      "style": { "margin-top": "20px" },
                      "props": {
                        "config": {
                          "api": "/api/v1/dashboard/pc/monetization/sales/lifetime/card_metrics",
                          "dateFilterType": "singleDaily",
                          "isConfirm": true,
                          "metricsList": [
                            "lifetime_revenue_after_refund"
                          ]
                        }
                      },
                      "children": [
                        {
                          "name": "CommonRow",
                          "className": "",
                          "type": "layout",
                          "style": {},
                          "props": {},
                          "children": [
                            {
                              "name": "CommonCol",
                              "className": "",
                              "type": "layout",
                              "style": {},
                              "props": {
                                "w": 24
                              },
                              "children": [
                                {
                                  "name": "PlatformCard",
                                  "className": "",
                                  "style": {},
                                  "type": "view",
                                  "props": {
                                    "config": {
                                      "componentMetrics": [
                                        {
                                          "metricKey": "lifetime_revenue_after_refund",
                                          "enName": "Lifetime Revenue After Refund",
                                          "cnName": "累计收入(剔除退款)",
                                          "rangeEnName": "Lifetime Revenue After Refund",
                                          "rangeCnName": "累计收入(剔除退款)",
                                          "preUnit": "$",
                                          "endUnit": "",
                                          "rainbowKey": "Pc Lifetime Revenue After Refund",
                                          "type": "decimals",
                                          "decimal": 2,
                                          "icon": "dollar",
                                          "position": ""
                                        }
                                      ]
                                    }
                                  },
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "name": "PlatformMetricsCo",
                      "className": "margin-t-10 dbd-lifetime-card-not-one",
                      "type": "view",
                      "style": { "margin-top": "20px" },
                      "props": {
                        "config": {
                          "api": "/api/v1/dashboard/pc/monetization/sales/lifetime/card_metrics",
                          "dateFilterType": "singleDaily",
                          "isConfirm": true,
                          "metricsList": [
                            "lifetime_net_revenue"
                          ]
                        }
                      },
                      "children": [
                        {
                          "name": "CommonRow",
                          "className": "",
                          "type": "layout",
                          "style": {},
                          "props": {},
                          "children": [
                            {
                              "name": "CommonCol",
                              "className": "",
                              "type": "layout",
                              "style": {},
                              "props": {
                                "w": 24
                              },
                              "children": [
                                {
                                  "name": "PlatformCard",
                                  "className": "",
                                  "style": {},
                                  "type": "view",
                                  "props": {
                                    "config": {
                                      "componentMetrics": [
                                        {
                                          "metricKey": "lifetime_net_revenue",
                                          "enName": "Lifetime Revenue After Refund & Tax",
                                          "cnName": "累计收入(剔除退款&税)",
                                          "rangeEnName": "Lifetime Revenue After Refund & Tax",
                                          "rangeCnName": "累计收入(剔除退款&税)",
                                          "preUnit": "$",
                                          "endUnit": "",
                                          "rainbowKey": "Pc Lifetime Revenue After Refund & Tax",
                                          "type": "decimals",
                                          "decimal": 2,
                                          "icon": "dollar",
                                          "position": ""
                                        }
                                      ]
                                    }
                                  },
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    },
                  ]
                },
                {
                  "name": "LifetimeSalesBreakDownServiceTransfer",
                  "className": "",
                  "type": "view",
                  "style": {},
                  "props": {
                    "tabMapConfig": {
                      "gross": {
                        "metric": [
                          "lifetime_full_game_gross_units",
                          "lifetime_gross_revenue"
                        ],
                        "topMetric": "lifetime_full_game_gross_units",
                        "extMetricMap": {
                          "lifetime_full_game_gross_units": "lifetime_gross_revenue",
                          "lifetime_gross_revenue": "lifetime_full_game_gross_units"
                        }
                      },
                      "after_refund": {
                        "isfund": true,
                        "metric": [
                          "lifetime_full_game_net_units",
                        ],
                        "topMetric": "lifetime_full_game_net_units",
                        "extMetricMap": {}
                      }
                    },
                    "config": {
                      "api": "/api/v1/dashboard/pc/monetization/sales/lifetime/multi_metrics_breakdown",
                      "byType": function (type) { return type === 'product' ? 'by_product' : 'by_category' },
                    }
                  },
                  "children": [
                    {
                      "name": "CommonRow",
                      "className": "dbd-saleOverview-row dbd-saleOverview-breakdown-row",
                      "type": "layout",
                      "style": { marginTop: 20 },
                      "props": {},
                      "children": [
                        {
                          "name": "CommonCol",
                          "className": "dbd-ingame-revenue-breakdown dbd-lifetime-sales-breakdown",
                          "type": "layout",
                          "style": {},
                          "props": {},
                          "children": [
                            {
                              "name": "IngameDlpTopChartContextTransfer",
                              "props": {
                                tabConfigMap: {
                                  "gross": {
                                    "radioConfig": {
                                      "dataKey": "by_type",
                                      "options": [
                                        {
                                          "nameEn": "Product",
                                          "nameCn": "产品",
                                          "value": "product",
                                          "bubbleEn": "",
                                          "bubbleCn": ""
                                        },
                                        {
                                          "nameEn": "Product Category",
                                          "nameCn": "产品类型",
                                          "value": "category",
                                          "bubbleEn": "",
                                          "bubbleCn": ""
                                        }
                                      ]
                                    },
                                    "top10TitleEn": "Lifetime Sales Breakdown",
                                    "top10TitleCn": "累计销售构成",
                                    "titleNameEn": function (type) { return type === 'product' ? 'Product' : 'Product Category' },
                                    "titleNameCn": function (type) { return type === 'product' ? '产品' : '产品类型' },
                                    "sortMetric": "lifetime_full_game_gross_units",
                                    "chart": [
                                      {
                                        "metric": "lifetime_full_game_gross_units",
                                        "name": "Lifetime Gross Base Game Units",
                                        "nameCn": "累计本体销量",
                                        "format": "thousandsInit",
                                        "percentFormat": "percent1Decimal"
                                      },
                                      {
                                        "metric": "lifetime_gross_revenue",
                                        "name": "Lifetime Gross Revenue($)",
                                        "nameCn": "累计总收入($)",
                                        "format": "thousands2Decimal",
                                        "percentFormat": "percent1Decimal"
                                      }
                                    ],
                                    "download": [
                                      {
                                        "key": "full_name",
                                        "header": "HEADER"
                                      },
                                      {
                                        "key": "lifetime_full_game_gross_units",
                                        "header": "Lifetime Gross Base Game Units",
                                        "headerCn": "累计本体销量"
                                      },
                                      {
                                        "key": "lifetime_full_game_gross_units_percentage",
                                        "header": "Share of All (Lifetime Gross Base Game Units)",
                                        "headerCn": "全局占比(累计本体销量)"
                                      },
                                      {
                                        "key": "lifetime_gross_revenue",
                                        "header": "Lifetime Gross Revenue($)",
                                        "headerCn": "累计总收入($)"
                                      },
                                      {
                                        "key": "lifetime_gross_revenue_percentage",
                                        "header": "Share of All (Lifetime Gross Revenue)",
                                        "headerCn": "全局占比(累计总收入)"
                                      }
                                    ],
                                    "isBasicSelector": true
                                  },
                                  "after_refund": {
                                    "segmentConfig": {
                                      "dataKey": "by_top10_metric",
                                      "options": [
                                        {
                                          "name": "Revenue After Refund($)",
                                          "nameCn": "收入(剔除退款)($)",
                                          "value": "lifetime_revenue_after_refund",
                                          "bubble": "",
                                          "bubbleCn": ""
                                        },
                                        {
                                          "name": "Revenue After Refund & Tax($)",
                                          "nameCn": "收入(剔除退款&税)($)",
                                          "value": "lifetime_net_revenue",
                                          "bubble": "",
                                          "bubbleCn": ""
                                        }
                                      ]
                                    },
                                    "radioConfig": {
                                      "dataKey": "by_type",
                                      "options": [
                                        {
                                          "nameEn": "Product",
                                          "nameCn": "产品",
                                          "value": "product",
                                          "bubbleEn": "",
                                          "bubbleCn": ""
                                        },
                                        {
                                          "nameEn": "Product Category",
                                          "nameCn": "产品类型",
                                          "value": "category",
                                          "bubbleEn": "",
                                          "bubbleCn": ""
                                        }
                                      ]
                                    },
                                    "top10TitleEn": "Lifetime Sales Breakdown",
                                    "top10TitleCn": "累计销售构成",
                                    "titleNameEn": function (type) { return type === 'product' ? 'Product' : 'Product Category' },
                                    "titleNameCn": function (type) { return type === 'product' ? '产品' : '产品类型' },
                                    "sortMetric": "lifetime_full_game_net_units",
                                    "chartConfig": {
                                      "lifetime_revenue_after_refund": [
                                        {
                                          "metric": "lifetime_revenue_after_refund",
                                          "name": "Lifetime Revenue After Refund($)",
                                          "nameCn": "收入(剔除退款)($)",
                                          "format": "thousands2Decimal",
                                          "percentFormat": "percent1Decimal"
                                        }
                                      ],
                                      "lifetime_net_revenue": [
                                        {
                                          "metric": "lifetime_net_revenue",
                                          "name": "Lifetime Revenue After Refund & Tax($)",
                                          "nameCn": "累计收入(剔除退款&税)($)",
                                          "format": "thousands2Decimal",
                                          "percentFormat": "percent1Decimal"
                                        }
                                      ],
                                    },
                                    "chart": [
                                      {
                                        "metric": "lifetime_full_game_net_units",
                                        "name": "Lifetime Base Game Units After Refund",
                                        "nameCn": "累计本体销量(剔除退款)",
                                        "format": "thousandsInit",
                                        "percentFormat": "percent1Decimal"
                                      },
                                    ],
                                    "downloadConfig": {
                                      "lifetime_revenue_after_refund": [
                                        {
                                          "key": "lifetime_revenue_after_refund",
                                          "header": "Lifetime Revenue After Refund($)",
                                          "headerCn": "收入(剔除退款)($)"
                                        },
                                        {
                                          "key": "lifetime_revenue_after_refund_percentage",
                                          "header": "Share of All (Lifetime Revenue After Refund)",
                                          "headerCn": "全局占比(收入(剔除退款))"
                                        }
                                      ],
                                      "lifetime_net_revenue": [
                                        {
                                          "key": "lifetime_net_revenue",
                                          "header": "Lifetime Revenue After Refund & Tax($)",
                                          "headerCn": "累计收入(剔除退款&税)($)"
                                        },
                                        {
                                          "key": "lifetime_net_revenue_percentage",
                                          "header": "Share of All (Lifetime Revenue After Refund & Tax)",
                                          "headerCn": "全局占比(累计收入(剔除退款&税))"
                                        }
                                      ],
                                    },
                                    "download": [
                                      {
                                        "key": "full_name",
                                        "header": "HEADER"
                                      },
                                      {
                                        "key": "lifetime_full_game_net_units",
                                        "header": "Lifetime Base Game Units After Refund",
                                        "headerCn": "累计本体销量(剔除退款)"
                                      },
                                      {
                                        "key": "lifetime_full_game_net_units_percentage",
                                        "header": "Share of All (Lifetime Base Game Units After Refund)",
                                        "headerCn": "全局占比(累计本体销量(剔除退款))"
                                      },
                                    ],
                                    "isBasicSelector": true
                                  }
                                }
                              }
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "name": "OverallTableCo",
              "className": "",
              "type": "view",
              "style": {
                "marginTop": "20px"
              },
              "props": {
                "config": {
                  "api": {
                    "tableApi": "/api/v1/dashboard/pc/monetization/sales/lifetime/overall_performance",
                    "tableDownloadApi": "/api/v1/dashboard/pc/monetization/sales/lifetime/overall_performance/download"
                  },
                  "titleEn": "Overall Performance",
                  "titleCn": "指标总体表现",
                  "dateFilterType": "singleDaily",
                  "defaultSort": [
                    {
                      "by": "product",
                      "order": ""
                    }
                  ],
                  "copyTitleList": [
                    "current"
                  ],
                  "showStatistic": [],
                  "dimensionConfig": {
                    "defaultAccumulation": [
                      "product",
                      "category"
                    ],
                    "filterDimsAndColumns": [
                      "date"
                    ],
                    "dateDisabled": false,
                    "isAutoSort": true
                  },
                  "valueTypeConfig": {
                    "isShowChange": false
                  },
                  "settingsConfig": {
                    "showTypeOptions": false
                  },
                  "downConfig": {
                    "showModalDataStat": false
                  },
                  "getParams": "function (params) { if (params && params.accumulation) { params.accumulation.not_by_date = false; return params; } else { return params } }",
                  "componentMetrics": [
                    {
                      "metricKey": "lifetime_gross_revenue",
                      "reqMetricKey": "lifetime_gross_revenue",
                      "enPercentWidth": 270,
                      "cnPercentWidth": 230,
                      "enWidth": 250,
                      "cnWidth": 200,
                      "enName": "Lifetime Gross Revenue($)",
                      "cnName": "累计总收入($)",
                      "rainbowKey": "Pc Lifetime Revenue",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "lifetime_net_revenue",
                      "reqMetricKey": "lifetime_net_revenue",
                      "enPercentWidth": 380,
                      "cnPercentWidth": 270,
                      "enWidth": 350,
                      "cnWidth": 250,
                      "enName": "Lifetime Revenue After Refund & Tax($)",
                      "cnName": "累计收入(剔除退款&税)($)",
                      "rainbowKey": "Pc Lifetime Revenue After Refund & Tax($)",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "lifetime_revenue_after_refund",
                      "reqMetricKey": "lifetime_revenue_after_refund",
                      "enPercentWidth": 350,
                      "cnPercentWidth": 250,
                      "enWidth": 300,
                      "cnWidth": 230,
                      "enName": "Lifetime Revenue After Refund($)",
                      "cnName": "累计收入(剔除退款)($)",
                      "rainbowKey": "Lifetime Revenue After Refund($)",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "lifetime_gross_units",
                      "reqMetricKey": "lifetime_gross_units",
                      "enPercentWidth": 270,
                      "cnPercentWidth": 200,
                      "enWidth": 250,
                      "cnWidth": 180,
                      "enName": "Lifetime Gross units",
                      "cnName": "累计总销量",
                      "rainbowKey": "Pc Lifetime Gross units",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "lifetime_units_after_refund",
                      "reqMetricKey": "lifetime_units_after_refund",
                      "enPercentWidth": 320,
                      "cnPercentWidth": 250,
                      "enWidth": 300,
                      "cnWidth": 230,
                      "enName": "Lifetime Units After Refund",
                      "cnName": "累计本体销量(剔除退款)",
                      "rainbowKey": "Pc Lifetime Units After Refund",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "lifetime_full_game_gross_units",
                      "reqMetricKey": "lifetime_full_game_gross_units",
                      "enPercentWidth": 320,
                      "cnPercentWidth": 200,
                      "enWidth": 300,
                      "cnWidth": 180,
                      "enName": "Lifetime Gross Base Game Units",
                      "cnName": "累计本体销量",
                      "rainbowKey": "Pc Lifetime Base Game Units",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "lifetime_full_game_net_units",
                      "reqMetricKey": "lifetime_full_game_net_units",
                      "enPercentWidth": 380,
                      "cnPercentWidth": 250,
                      "enWidth": 350,
                      "cnWidth": 230,
                      "enName": "Lifetime Base Game Units After Refund",
                      "cnName": "累计本体销量(剔除退款)",
                      "rainbowKey": "Pc Lifetime Base Game Units After Refund",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "lifetime_chargeback_revenue",
                      "reqMetricKey": "lifetime_chargeback_revenue",
                      "enPercentWidth": 280,
                      "cnPercentWidth": 250,
                      "enWidth": 260,
                      "cnWidth": 230,
                      "enName": "Lifetime Refund Revenue($)",
                      "cnName": "累计退款收入($)",
                      "rainbowKey": "Pc Lifetime Refund Revenue",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "lifetime_refund_rate",
                      "reqMetricKey": "lifetime_refund_rate",
                      "enPercentWidth": 220,
                      "cnPercentWidth": 200,
                      "enWidth": 200,
                      "cnWidth": 180,
                      "enName": "Lifetime Refund Rate",
                      "cnName": "累计退款率",
                      "rainbowKey": "Pc Lifetime Refund Rate",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 1
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    }
  ]
};